import React, { useState, useEffect } from 'react';

import IntegrationsSetupListItem from './IntegrationsSetupListItem';
import IntegrationsSetupListItemCreateModal from './IntegrationsSetupListItemCreateModal';
import IntegrationsSetupListItemInstructionsModal from './IntegrationsSetupListItemInstructionsModal';

export default function IntegrationsSetupList(props) {
    const [configuringProvider, setConfiguringProvider] = useState({});
    const [showIntegrationInstruction, setShowIntegrationInstruction] = useState({});
    const [initialStep, setInitialStep] = useState(null);
    const [initialProvider, setInitialProvider] = useState(null);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const stepNumber = urlParams.get('step') || null;
        const providerCode = urlParams.get('provider') || null;

        setInitialProvider(providerCode);
        setInitialStep(stepNumber);
    }, []);

    useEffect(() => {
        if (initialProvider) {
            const provider = props.providers.find((row) => {
                return row.code === initialProvider;
            });

            if (provider && provider.can_be_configured) {
                setConfiguringProvider(provider);
            }
        }
    }, [initialProvider, props.providers]);

    useEffect(() => {
        if (Object.keys(configuringProvider).length > 0) {
            $('#create-integration').modal('show');
        }
    }, [configuringProvider]);

    useEffect(() => {
        if (Object.keys(showIntegrationInstruction).length > 0) {
            $('#integration-setup-instruction-modal').modal('show');
        }
    }, [showIntegrationInstruction]);

    const configureProvider = (provider) => {
        if (provider.can_be_configured) {
            setConfiguringProvider(provider);
        }
    };

    const showSetupInfo = (provider) => {
        setShowIntegrationInstruction(provider);
    };

    const successHandler = () => {
        setConfiguringProvider({});
        setShowIntegrationInstruction({});
        props.fetchData();
        $('#create-integration').modal('hide');
        $('#integration-setup-instruction-modal').modal('hide');
    };

    const closeModal = () => {
        setConfiguringProvider({});
        setShowIntegrationInstruction({});
        $('#create-integration').modal('hide');
        $('#integration-setup-instruction-modal').modal('hide');
    };

    const getFormName = (providerName) => {
        if (providerName === 'Dynamics 365 Business Central') {
            return 'IntegrationsSetupListItemSaveBcForm';
        }

        if (providerName === 'Xero') {
            return 'IntegrationsSetupListItemSaveXeroForm';
        }

        return null;
    };

    return (
        <div className="tw-grid tw-grid-cols-3 tw-gap-3">
            {props.providers.map((provider) => {
                return (
                    <IntegrationsSetupListItem
                        key={provider.uuid}
                        provider={provider}
                        configureProvider={(e) => {
                            configureProvider(provider);
                        }}
                        displaySetupInfo={(e) => {
                            showSetupInfo(provider);
                        }}
                        checkConnectivityUrl={props.checkConnectivityUrl}
                        initialStep={initialStep}
                    />
                );
            })}
            {Object.keys(configuringProvider).length > 0 && (
                <IntegrationsSetupListItemCreateModal
                    provider={configuringProvider}
                    closeHandler={closeModal}
                    successHandler={successHandler}
                    storeUrl={props.storeUrl}
                    updateUrl={props.updateUrl}
                    testConnectionUrl={props.testConnectionUrl}
                    componentName={getFormName(configuringProvider.name)}
                    initialStep={initialStep}
                />
            )}
            <IntegrationsSetupListItemInstructionsModal provider={showIntegrationInstruction} closeHandler={closeModal} />
        </div>
    );
}
